import { render, staticRenderFns } from "./SalesDashboardAdRevenueNumber.vue?vue&type=template&id=08f0d944&"
import script from "./SalesDashboardAdRevenueNumber.vue?vue&type=script&lang=js&"
export * from "./SalesDashboardAdRevenueNumber.vue?vue&type=script&lang=js&"
import style0 from "./SalesDashboardAdRevenueNumber.vue?vue&type=style&index=0&id=08f0d944&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports